import inlineHtm from "webutils/address-info.inline.htm";
import multilineHtm from "webutils/address-info.multiline.htm";
import minimalHtm from "webutils/address-info.minimal.htm";
import controller from "webutils/address-info.controller";

export default {
  bindings: {
    address: "=",
    type: "@",
    allowEdit: "<",
    key: "@",
    purchaser: "=",
    hideName: "<",
    hideCompanyName: "<",
    hideAddressId: "<",
    hidePhone: "<",
    hideEmail: "<",
  },
  templateUrl($element, $attrs) {
    return (
      $attrs.templateUrl ||
      ($attrs.type === "inline"
        ? inlineHtm
        : $attrs.type === "minimal"
        ? minimalHtm
        : multilineHtm)
    );
  },
  controller,
};
